<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld :temperatureData=sensorData></HelloWorld>
    <TemperatureChart :temperatureData=sensorData :loading=loading></TemperatureChart>
  </div>
</template>


<script>
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue';
    import TemperatureChart from '@/components/TemperatureChart.vue';

    export default {
        name: 'home',
        mixins: [],
        components: {
            HelloWorld,
            TemperatureChart
        },
        data: function () {
            return {
                url: 'https://code.gufere.ch/api/v1/raspitemp',
                loading: true,
                sensorData: [],
                loadData: [{timestamp: "1576571306402", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:26"},
                    {timestamp: "1576571311888", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:31"},
                    {timestamp: "1576571316450", temperature: "21.9", humidity: "40.2", date: "17. Dezember 2019, 09:28:36"},
                    {timestamp: "1576571321498", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:41"},
                    {timestamp: "1576571326547", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:46"},
                    {timestamp: "1576571332544", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:52"},
                    {timestamp: "1576571336625", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:28:56"},
                    {timestamp: "1576571341660", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:29:01"},
                    {timestamp: "1576571346661", temperature: "21.9", humidity: "40.3", date: "17. Dezember 2019, 09:29:06"},
                    {timestamp: "1576631587627", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:07"},
                    {timestamp: "1576631592628", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:12"},
                    {timestamp: "1576631597629", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:17"},
                    {timestamp: "1576631602630", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:22"},
                    {timestamp: "1576631607156", temperature: "22.1", humidity: "40.5", date: "18. Dezember 2019, 02:13:27"},
                    {timestamp: "1576631612157", temperature: "22.1", humidity: "40.7", date: "18. Dezember 2019, 02:13:32"},
                    {timestamp: "1576631617157", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:37"},
                    {timestamp: "1576631622158", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:42"},
                    {timestamp: "1576631627200", temperature: "22.1", humidity: "40.6", date: "18. Dezember 2019, 02:13:47"},
                    {timestamp: "1576681762624", temperature: "21.9", humidity: "38.8", date: "18. Dezember 2019, 16:09:22"},
                    {timestamp: "1576681767677", temperature: "21.8", humidity: "38.7", date: "18. Dezember 2019, 16:09:27"},
                    {timestamp: "1576681772677", temperature: "21.8", humidity: "38.7", date: "18. Dezember 2019, 16:09:32"},
                    {timestamp: "1576681777677", temperature: "21.8", humidity: "38.7", date: "18. Dezember 2019, 16:09:37"},
                    {timestamp: "1576681782677", temperature: "21.9", humidity: "38.8", date: "18. Dezember 2019, 16:09:42"},
                    {timestamp: "1576681787678", temperature: "21.8", humidity: "38.7", date: "18. Dezember 2019, 16:09:47"},
                    {timestamp: "1576681792729", temperature: "21.9", humidity: "38.8", date: "18. Dezember 2019, 16:09:52"},
                    {timestamp: "1576681797778", temperature: "21.9", humidity: "38.8", date: "18. Dezember 2019, 16:09:57"},
                    {timestamp: "1576681803803", temperature: "21.8", humidity: "38.6", date: "18. Dezember 2019, 16:10:03"}]
            };
        },
        mounted() {
            this.axios.get(this.url)
                .then(response => {
                    const ret = [];
                    for (let x = 0; x < response.data.length; ++x) {
                        let item = {};
                        item.timestamp = response.data[x].timestamp;
                        item.temperature = response.data[x].temperature;
                        item.humidity = response.data[x].humidity;
                        let myDate = new Date(item.timestamp * 1);
                        item.date = myDate.toLocaleDateString('de-CH', {year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'});
                        ret.push(item);
                    }
                    //console.log('temperatureData', ret);
                    this.sensorData = ret;
                })
                .catch(error => {
                    return error;
                })
                .finally(() => this.loading = false);
        }
    }
</script>
